module.exports = __webpack_public_path__ + "img/class-portal-manage.7084f829.svg";